module.exports = __webpack_public_path__ + "static/img/2.d14f0f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/2.png
// module id = gaQ4
// module chunks = 0